export default __webpack_public_path__ + "static/media/cnaps-mobile-app.d942a7b2.svg";